import React from 'react'
import './paging.css'

class PagingBar extends React.Component{
	constructor(props){
		 super(props)
		 this.state={
		 	activeNum:0
		 }
		
	}
	 componentDidMount(){

    	this.handlePageCon()
   
  	}
	pageFn(num){

		this.props.pageNext(num)
		this.setState({
			activeNum:num-1
		})
	}
	handlePageCon(){
		const totalPage = this.props.totalPage
		var arr = []
		for(let i=0;i<totalPage;i++){
			
			arr.push('')
		}
	
		return arr
	}
	render(){
		const totalPage = this.props.totalPage
		const arr = this.handlePageCon()
		
		return (
			<div className="page-box">

				
				{
					arr.map((item,i)=>{
						return <span key={i} className={this.state.activeNum==i?'active':''} onClick={()=>this.pageFn(i+1)}>{i+1}</span>
					})

				}
			
				{arr.length===0?null:<em>共{arr.length}页</em>}

			</div>

		)


	}
}
export default PagingBar


// WEBPACK FOOTER //
// ./src/component/paging-bar/paging.js